/**
 * Carregamento sob demanda da fonte japonesa (Tarefa 8 / decisão D5).
 *
 * `@fontsource-variable/noto-sans-jp` é self-hosted (npm, nada de CDN externo):
 * o pacote entrega WOFF2 fatiado por `unicode-range` (124 slices), então o
 * browser baixa só os slices que a página usa, com `font-display: swap` já
 * embutido no CSS do pacote.
 *
 * O `import()` dinâmico é o que garante o requisito E2 da rubrica: o CSS da
 * fonte vira um chunk assíncrono próprio e uma sessão em pt/en/es NUNCA baixa
 * um byte dela. Chamado apenas por `ensureLocaleLoaded('ja')`, junto do
 * `ja.json` — fonte e dicionário entram na mesma viagem.
 */
let fontPromise: Promise<void> | null = null

export function loadJapaneseFont(): Promise<void> {
  if (!fontPromise) {
    fontPromise = import('@fontsource-variable/noto-sans-jp')
      .then(() => undefined)
      .catch((error: unknown) => {
        // A fonte é progressive enhancement: sem ela o stack do sistema
        // (Hiragino/Yu Gothic/Noto CJK) ainda renderiza japonês legível.
        console.warn('Falha ao carregar Noto Sans JP; usando o stack do sistema.', error)
      })
  }
  return fontPromise
}

/** Só para teste: reseta a memoização entre casos. */
export function resetJapaneseFontLoader(): void {
  fontPromise = null
}

/** Só para teste: informa se a fonte japonesa já foi solicitada. */
export function isJapaneseFontRequested(): boolean {
  return fontPromise !== null
}
